<mat-form-field appearance="outline" class="mb-2 w-full">
  <mat-label>{{ label }}</mat-label>

  <ng-container *ngIf="options$ | async as optionsList; else noOptionsTpl">
    <input
      class="w-full"
      type="text"
      [placeholder]="placeholder"
      matInput
      [formControl]="filterInputControl"
      [matAutocomplete]="autocompleteBox"
      #autocompleteTrigger="matAutocompleteTrigger"
    >

    <mat-autocomplete #autocompleteBox="matAutocomplete" [displayWith]="optionsList?.length ? getTitle.bind(this) : null">
      <mat-option *ngIf="showDefaultOption" [value]="defaultOption.value" (click)="onSelect()">{{ defaultOption.label }}</mat-option>
      <mat-option *ngFor="let item of optionsList | filterBy: filterInputControl.value" [value]="item[valueKey]" (click)="onSelect(item)">
        <span>{{item[labelKey]}}</span>
      </mat-option>
    </mat-autocomplete>
  </ng-container>

  <ng-template #noOptionsTpl>
    <input
      type="text"
      [placeholder]="placeholder"
      matInput
      disabled
    >
  </ng-template>

  <fa-icon
    *ngIf="filterInputControl.value === null || filterInputControl.value === undefined || filterInputControl.value === ''"
    matSuffix
    aria-hidden="true"
    class="si-icon si-select-arrow cursor-pointer"
    [class.si-select-arrow--open]="autocompleteTriggerRef?.panelOpen"
    [icon]="['fal', 'chevron-down']"
    (click)="onChevronClick($event)"
  ></fa-icon>

  <button *ngIf="filterInputControl.value !== null && filterInputControl.value !== undefined && filterInputControl.value !== '' && !hideClearButton" matSuffix matIconButton class="mat-primary" (click)="onClear()" [disabled]="isDisabled">
    <fa-icon class="si-icon" [icon]="['fal', 'xmark']"></fa-icon>
  </button>
  <mat-hint><ng-content></ng-content></mat-hint>
</mat-form-field>
